import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import bioSearchSettingCn from '@patsnap-biz/bio-search-setting/locales/cn';
import bioSearchSettingEn from '@patsnap-biz/bio-search-setting/locales/en';
import bioSearchSettingJp from '@patsnap-biz/bio-search-setting/locales/jp';
import bioSearchSettingTw from '@patsnap-biz/bio-search-setting/locales/tw';
import elementCN from 'element-ui/lib/locale/lang/zh-CN';
import elementTW from 'element-ui/lib/locale/lang/zh-TW';
import elementEN from 'element-ui/lib/locale/lang/en';
import elementJP from 'element-ui/lib/locale/lang/ja';
import ElementLocale from 'element-ui/lib/locale';
import customFieldLabelPane from '@patsnap-biz/custom-field-label-pane/locales';
import emailAlertI18n from '@patsnap-biz/email-alert/locales';
import { setI18nInstance } from './i18nInstance';
import { initSaveToWorkspaceI18n } from 'library-@/config/save-to-workspace-config';

Vue.use(VueI18n);
Vue.mixin({
    computed: {
        $lang() {
            return this.$i18n.locale;
        },
    },
});

async function langGetter(lang) {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/analytics-patent-view/cn.json'),
            import('CommonMessages/common-country/cn.json'),
            import('CommonMessages/common-patent/cn.json'),
            import('CommonMessages/common-errorcode/cn.json'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/analytics-patent-view/tw.json'),
            import('CommonMessages/common-country/tw.json'),
            import('CommonMessages/common-patent/tw.json'),
            import('CommonMessages/common-errorcode/tw.json'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/analytics-patent-view/en.json'),
            import('CommonMessages/common-country/en.json'),
            import('CommonMessages/common-patent/en.json'),
            import('CommonMessages/common-errorcode/en.json'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/analytics-patent-view/jp.json'),
            import('CommonMessages/common-country/jp.json'),
            import('CommonMessages/common-patent/jp.json'),
            import('CommonMessages/common-errorcode/jp.json'),
        ]);
    }
    const data = results.reduce((obj, data) => _.merge(obj, data), {});
    return { [lang]: data };
}

let i18n;

export default async function(lang, fallbackLocale = 'en') {
    if (!i18n) {
        const translation = await langGetter(lang);
        const elementI18n = { en: elementEN, jp: elementJP, cn: elementCN, tw: elementTW };
        const bioSearchSetting = { en: bioSearchSettingEn, jp: bioSearchSettingJp, cn: bioSearchSettingCn, tw: bioSearchSettingTw };
        const messages = _.merge({}, elementI18n, emailAlertI18n, customFieldLabelPane, bioSearchSetting, translation);
        i18n = new VueI18n({
            locale: lang,
            fallbackLocale,
            messages,
        });
        ElementLocale.i18n((key, value) => i18n.t(key, value));
        setI18nInstance(i18n);

        initSaveToWorkspaceI18n({
            i18n,
            lang,
        });
    }
    return i18n;
}
